import React from "react";
import CATEGORIES from "utils/categories";
import { renderProgressIcon } from "utils/helpers";
import IconCompleted from "assets/Icon-Completed.svg";

import "styles/SidebarCategory.scss";

const SidebarCategory = ({
  active,
  description,
  category,
  complete,
  showInputSummary,
  number,
}) => {
  const { displayName, iconSource, iconDimensions } = category;

  let categorySpecial = "";
  if (number === 0) {
    categorySpecial = "sidebar-category-first";
  } else if (number === CATEGORIES.length - 1) {
    categorySpecial = "sidebar-category-last";
  }

  return (
    <div className="sidebar-category-inner-container">
      {active && <div className="highlight-block" />}
      <div className={"sidebar-category flex-space-between " + categorySpecial}>
        <div className="flex">
          <div className="sidebar-icon-container">
            {renderProgressIcon(
              displayName,
              active,
              complete,
              iconSource,
              iconDimensions
            )}
          </div>
          <div className="right-padding">
            <div className="title">
              {displayName}
              {complete && (
                <img
                  className="completed-checkbox margin-left"
                  src={IconCompleted}
                  alt="deselect field"
                  width="12px"
                />
              )}
            </div>
            <div className="sidebar-description">{description}</div>
          </div>
        </div>
        {complete && !showInputSummary && (
          <div className="edit">
            <p>Edit</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SidebarCategory;
